/*
  Cart page controller (/cart, sections/main-cart.liquid).

  Replaces the old "type a number, then press Update cart" flow with +/- steppers
  that apply immediately, and adds a Clear cart button. Both were asked for by
  Jose: the bare number input's native spinner arrows are unusable on mobile, and
  there was no way to empty the cart at all.

  Gift lines are rendered without a quantity control by zen-cart-line.liquid, so
  there is nothing here to guard -- but zen-gift-guard.js still reconciles the
  cart after every /cart/change.js this file issues, which is what actually
  enforces the one-gift-per-offer rule.

  Progressive enhancement: without JS the form still posts to /cart with
  updates[] and the "Update cart" button, exactly as before.
*/
(function () {
  "use strict";

  var form = document.querySelector("[data-zen-cart-form]");
  if (!form || !window.fetch) return;

  var section = form.closest(".zen-fallback--cart") || document.body;

  /* The submit button is only useful in the no-JS path. `hidden` alone is not
     enough: it only carries the UA stylesheet's display:none, which .zen-button's
     own display rule overrides -- so the button stayed visible. The inline style
     wins outright; the attribute is kept for assistive tech. */
  var updateButton = form.querySelector(".zen-cart-items__update");
  if (updateButton) {
    updateButton.hidden = true;
    updateButton.style.display = "none";
  }

  var busy = false;

  function setBusy(state) {
    busy = state;
    section.classList.toggle("is-cart-busy", Boolean(state));
    form.querySelectorAll("button, input").forEach(function (control) {
      if (control.hasAttribute("data-zen-cart-keep-enabled")) return;
      control.disabled = Boolean(state);
    });
  }

  function requestJson(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { Accept: "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error("Cart request failed");
      return response.json();
    });
  }

  /* The cart page is server-rendered (line prices, discounts and the free-gift
     lines all come from Liquid), so re-rendering it correctly in JS would mean
     duplicating that logic. Reloading is the honest option and keeps one source
     of truth for what the customer sees. */
  function reloadCart() {
    window.location.reload();
  }

  function failed(message) {
    setBusy(false);
    window.alert(message || "Sorry, we couldn't update your cart. Please try again.");
  }

  function changeLine(lineKey, quantity) {
    if (busy || !lineKey) return;
    setBusy(true);
    requestJson("/cart/change.js", { id: lineKey, quantity: Math.max(0, quantity) })
      .then(reloadCart)
      .catch(function () {
        failed();
      });
  }

  function currentQuantity(lineKey) {
    var input = form.querySelector('.zen-cart-line__qty-input[data-line-key="' + lineKey + '"]');
    return input ? Math.max(0, Number(input.value) || 0) : null;
  }

  form.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var step = target.closest("[data-zen-qty-step]");
    if (step) {
      event.preventDefault();
      var stepKey = step.dataset.lineKey;
      var quantity = currentQuantity(stepKey);
      if (quantity === null) return;
      changeLine(stepKey, quantity + Number(step.dataset.zenQtyStep));
      return;
    }

    var remove = target.closest("[data-zen-cart-remove]");
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.lineKey, 0);
      return;
    }

    var clear = target.closest("[data-zen-cart-clear]");
    if (clear) {
      event.preventDefault();
      if (busy) return;
      if (!window.confirm("Remove everything from your cart?")) return;
      setBusy(true);
      fetch("/cart/clear.js", { method: "POST", headers: { Accept: "application/json" } })
        .then(function (response) {
          if (!response.ok) throw new Error("Clear failed");
          reloadCart();
        })
        .catch(function () {
          failed("Sorry, we couldn't empty your cart. Please try again.");
        });
    }
  });

  /* Typing a quantity directly still works -- it commits on blur/Enter rather
     than needing a separate Update press. */
  form.addEventListener("change", function (event) {
    var input = event.target;
    if (!input.matches || !input.matches(".zen-cart-line__qty-input")) return;
    changeLine(input.dataset.lineKey, Math.max(0, Number(input.value) || 0));
  });

  form.addEventListener("keydown", function (event) {
    if (event.key !== "Enter") return;
    var input = event.target;
    if (!input.matches || !input.matches(".zen-cart-line__qty-input")) return;
    event.preventDefault();
    input.blur();
  });
})();
